import { GenericRepository } from '@/repository/GenericRepository';
import {
  CreateFlagDefinitionInput,
  CreateFlagDefinitionMutation,
  CreateFlagDefinitionMutationVariables,
  FlagDefinition,
  UpdateFlagDefinitionInput,
  UpdateFlagDefinitionMutation,
  UpdateFlagDefinitionMutationVariables,
} from '@/API';
import * as mutations from '@/graphql/mutations';
import { searchFlagDefinitions } from '@/graphql/queries';
import { GraphQLOptionsV6, GraphQLResult } from '@aws-amplify/api-graphql';

/**
 * Repository for managing FlagDefinition model
 */
export class FlagDefinitionRepository extends GenericRepository<FlagDefinition> {
  constructor() {
    super();
  }

  async search(queryVariables: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: searchFlagDefinitions,
        variables: queryVariables,
      })
    ).data.searchFlagDefinitions;
  }

  public async save(input: CreateFlagDefinitionInput): Promise<FlagDefinition> {
    const response = (await this.client.graphql({
      query: mutations.createFlagDefinition,
      variables: { input } as CreateFlagDefinitionMutationVariables,
    })) as GraphQLResult<CreateFlagDefinitionMutation>;
    return response.data!.createFlagDefinition!;
  }

  public async update(
    input: UpdateFlagDefinitionInput
  ): Promise<FlagDefinition> {
    const response = (await this.client.graphql({
      query: mutations.updateFlagDefinition,
      variables: { input } as UpdateFlagDefinitionMutationVariables,
    })) as GraphQLResult<UpdateFlagDefinitionMutation>;
    return response.data!.updateFlagDefinition!;
  }
}
